import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ChevronRight",
  "use": "ChevronRight-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"ChevronRight\">\n  <path d=\"M8.4 7.6l8.2 8.4-8.2 8.4L12 28l11.6-12L12 4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol